<template>
	<div>
		<footer v-show="designtext" class="pre-footer">
			<client-only>
				<marquee-container>
					<template #content>
						<p>{{ designtext }}</p>
					</template>
				</marquee-container>
			</client-only>
		</footer>
	</div>
</template>

<script setup>
defineProps({
	designtext: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.pre-footer {
	width: 100%;
	color: #658ad4;
	font-size: 150px;
	overflow: hidden;
	margin: 0 auto 80px;
}

.small-row {
	padding: 50px 0;
}

@media (max-width: 960px) {
	.pre-footer {
		font-size: 110px !important;
		margin: 0 auto 70px;
	}
}

@media (max-width: 600px) {
	.pre-footer {
		font-size: 70px !important;
		margin: 0 auto 60px;
	}
}
</style>
